/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRemoteSessionIssuerDuplicatePreflightSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRemoteSessionIssuerDuplicatePreflightSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRemoteSessionIssuerDuplicatePreflightSecurity = {
  option1?: GetRemoteSessionIssuerDuplicatePreflightSecurityOption1 | undefined;
  option2?: GetRemoteSessionIssuerDuplicatePreflightSecurityOption2 | undefined;
};

export type GetRemoteSessionIssuerDuplicatePreflightRequest = {
  /**
   * The upstream issuer URL being entered (e.g. https://login.linear.app). Empty or unparseable returns no matches.
   */
  issuer?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRemoteSessionIssuerDuplicatePreflightSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRemoteSessionIssuerDuplicatePreflightSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption1$Outbound,
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getRemoteSessionIssuerDuplicatePreflightSecurityOption1ToJSON(
  getRemoteSessionIssuerDuplicatePreflightSecurityOption1:
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption1,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption1$outboundSchema
      .parse(getRemoteSessionIssuerDuplicatePreflightSecurityOption1),
  );
}

/** @internal */
export type GetRemoteSessionIssuerDuplicatePreflightSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRemoteSessionIssuerDuplicatePreflightSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption2$Outbound,
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getRemoteSessionIssuerDuplicatePreflightSecurityOption2ToJSON(
  getRemoteSessionIssuerDuplicatePreflightSecurityOption2:
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption2,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerDuplicatePreflightSecurityOption2$outboundSchema
      .parse(getRemoteSessionIssuerDuplicatePreflightSecurityOption2),
  );
}

/** @internal */
export type GetRemoteSessionIssuerDuplicatePreflightSecurity$Outbound = {
  Option1?:
    | GetRemoteSessionIssuerDuplicatePreflightSecurityOption1$Outbound
    | undefined;
  Option2?:
    | GetRemoteSessionIssuerDuplicatePreflightSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const GetRemoteSessionIssuerDuplicatePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionIssuerDuplicatePreflightSecurity$Outbound,
    GetRemoteSessionIssuerDuplicatePreflightSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetRemoteSessionIssuerDuplicatePreflightSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetRemoteSessionIssuerDuplicatePreflightSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getRemoteSessionIssuerDuplicatePreflightSecurityToJSON(
  getRemoteSessionIssuerDuplicatePreflightSecurity:
    GetRemoteSessionIssuerDuplicatePreflightSecurity,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerDuplicatePreflightSecurity$outboundSchema.parse(
      getRemoteSessionIssuerDuplicatePreflightSecurity,
    ),
  );
}

/** @internal */
export type GetRemoteSessionIssuerDuplicatePreflightRequest$Outbound = {
  issuer?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRemoteSessionIssuerDuplicatePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionIssuerDuplicatePreflightRequest$Outbound,
    GetRemoteSessionIssuerDuplicatePreflightRequest
  > = z.pipe(
    z.object({
      issuer: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function getRemoteSessionIssuerDuplicatePreflightRequestToJSON(
  getRemoteSessionIssuerDuplicatePreflightRequest:
    GetRemoteSessionIssuerDuplicatePreflightRequest,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerDuplicatePreflightRequest$outboundSchema.parse(
      getRemoteSessionIssuerDuplicatePreflightRequest,
    ),
  );
}
